exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Image-module__button___1CrU7{width:100%}.Image-module__button___1CrU7 .Image-module__img___1jyxg{width:100%;max-height:500px;border-radius:7px}", ""]);

// exports
exports.locals = {
	"button": "Image-module__button___1CrU7",
	"img": "Image-module__img___1jyxg"
};